import { COLORS } from 'global/configs/theme/defaults'
import palette from '../palette'

// TODO: Delete these overwrites after the colors are updated in BDS

export default {
  root: {
    // default color
    color: COLORS.ACTIVE_PLACEHOLDER_TEXT,
    fontSize: '12px !important',
    marginBottom: 2,

    '&.Mui-focused': {
      color: COLORS.ACTIVE_PLACEHOLDER_TEXT,

      '&.Mui-error': {
        color: palette.error.main
      }
    },

    '&.Mui-disabled': {
      // disabled color
      color: COLORS.DISABLED_PLACEHOLDER_TEXT
    }
  }
}
